import { render } from "./social_schedule.vue?vue&type=template&id=675b1114&scoped=true"
import script from "./social_schedule.vue?vue&type=script&lang=js"
export * from "./social_schedule.vue?vue&type=script&lang=js"

import "./social_schedule.vue?vue&type=style&index=0&id=675b1114&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675b1114"]])

export default __exports__